<template>
  <v-container>
    <div>
      <v-row justify="space-between">
        <v-col cols="12" sm="5" justify="center">
          <p class="header-title"> {{ $t('contact.contact_management') }} </p>
        </v-col>

        <v-col cols="12" sm="7">
          <div class="d-flex flex-row-reverse">
            <v-btn color="primary" dark @click="getData" class="mr-5">{{ $t('common.refresh') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-data-table :headers="headers" :items="desserts" :search="search" class="elevation-1" hide-default-footer
                  :page.sync="page" :loading="loading" :items-per-page="itemsPerPage" @page-count="pageCount = $event">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name"
                              v-bind:label="$t('location_assign.select_province')" return-object outlined
                              dense></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectDistrict" :items="districts" item-text="district_name"
                              v-bind:label="$t('location_assign.select_district')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectOrderUnit" :items="orderUnits" item-text="name"
                              v-bind:label="$t('location_assign.order_unit')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectOption" :items="options" item-text="title"
                              v-bind:label="$t('order_unit.option')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-toolbar>

      </template>

      <template v-slot:[`item.code`]="{ item }">
        <div>
          <span>
                {{item.code}}
          </span>
        </div>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" @click="deleteItem(item)">
              delete
            </v-icon>

          </template>
          <span> {{ $t('tooltip_infor.delete') }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.target`]="{ item }">
        <div class="contentAddress">
          <span>
                {{item.target.name}}
          </span>
        </div>
      </template>

      <template v-slot:[`item.sale`]="{ item }">
        <div class="contentAddress" v-if="item.sale">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.sale.avatar" :src="baseImage + item.sale.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.sale.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.sale.nickname }}
              </span>
        </div>
        <div class="contentAddress" v-else>
          <span>
                {{ $t('order_unit.unassign') }}
          </span>
        </div>
      </template>


      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>


  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    overlay: false,
    isSearching: false,

    show: false,
    e1: 0,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    isEdit: false,

    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    options: [
      {title: i18n.t('common.all'), value: -1},
      {title: i18n.t('common.owner_option'), value: 1}
    ],

    selectOption: {title: i18n.t('common.all'), value: -1},

    modal: false,

    dialogEditTarget: false,

    firstEdit: true,
    search: '',
    dialog: false,

    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index'},
      {text: i18n.t('contact.code'), value: 'code'},
      {text: i18n.t('contact.name'), value: 'name'},

      {text: i18n.t('contact.target'), value: 'target'},
      {text: '', sortable: false, value: 'target.name', align: ' d-none'},

      {text: i18n.t('contact.staff'), value: 'sale'},
      {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},

      {text: '', value: 'action', sortable: false}
    ],

    desserts: [],
    originalDesserts: [],

    editedIndex: -1,
    editedItem: null,
    defaultItem: {},

    selectDepartment: null,
    departments: [],

    selectTeam: null,
    teams: [],

    selectStaff: null,
    staffs: [],

    provinces: [],
    selectProvince: {},

    selectDistrict: null,
    districts: [],

    selectOrderUnit: {},
    orderUnits: []
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? i18n.t('staff_management.add_management') : i18n.t('staff_management.edit_management')
    },

    computedDateFormatted() {
      return this.formatDate(this.date)
    },
  },

  components: {

  },

  watch: {
    selectProvince(val) {
      if (val) {
        this.getDistrictByProvinceID(val.province_id);
      }
    },
    //
    selectDistrict(val) {
      if (val) {
        this.getOrderUnitByDistrict(val._id);
      }
    },

    selectOrderUnit(val) {
      if (val) {
        this.filterData();
      }
    },

    selectOption(val) {
      if (val) {
        this.filterData();
      }
    }
  },

  async created() {
    await this.getProvince();
    await this.getData();

    this.isSearching = true;
  },

  async mounted() {

  },

  methods: {
    initialize() {
    },

    filterData() {
      if (!this.originalDesserts || this.originalDesserts.length == 0) {
        return;
      }

      const self = this;

      if (this.selectProvince) {
        this.desserts = [].concat(this.originalDesserts.filter(item => self.selectProvince._id === item.target.orderUnit.vtProvince._id));
      }

      if (self.selectDistrict._id !== "-1") {
        self.desserts = [].concat(self.desserts.filter(function(item) {

          if (item.target.orderUnit.vtDistrict) {
            return item.target.orderUnit.vtDistrict._id === self.selectDistrict._id;
          }
        }));
      }

      if (self.selectOrderUnit._id !== "-1") {
        self.desserts = [].concat(self.desserts.filter(function(item) {
          if (item.target.orderUnit) {
            return item.target.orderUnit._id === self.selectOrderUnit._id;
          }
        }));
      }

      if (this.selectOption.value !== -1) {
        this.desserts = [].concat(this.desserts.filter(item => this.$getUserID === item.sale._id));
      }

      this.desserts.forEach((item, index) => item.index = index + 1);
      this.totalItems = this.desserts.length;
    },

    async getData() {
      this.overlay = this.isSearching;
      try {
        this.originalDesserts = await this.$getAllContact();
        console.log(this.originalDesserts);

        this.overlay = false;
        this.loading = false;

        this.filterData();
        // if (this.$isAdmin) {
        //   this.desserts = await this.$getAllTargets();
        // } else {
        //   if (this.$getUserCategory === 1) {
        //     this.desserts = await this.$getTargetOfMine();
        //   } else {
        //     this.desserts = await this.$getTargetInContext();
        //   }
        // }
      } catch (e) {
        console.log(e.stack);
      }
    },

    getStringByActivate(value) {
      if (value == 0) {
        return i18n.t('target.unapproved')
      } else if (value == 1) {
        return i18n.t('target.approved')
      }
    },

    async deleteItem(item) {
      const agree = confirm(i18n.t('common.confirm_delete'))

      if (agree) {
        const response = await this.$http.delete('/contact/' + item._id);
        if(response.data && response.data.success) {
          this.desserts.splice(item.index - 1, 1);
          this.desserts.forEach((item, index) =>item.index = index + 1);
        } else if(response.data && !response.data.success) {
          alert(i18n.t(response.data.message));
        } else {
          alert(i18n.t('validate.request_error'));
        }
      }
    },

    async getOrderUnitByDistrict(districtId) {
      let contextArr;
      if (districtId === "-1") {
        contextArr = await this.$getAllOrderUnitByProvince(this.selectProvince._id);
      } else {
        contextArr = await this.$getAllOrderUnitByDistrict(districtId);
      }

      const optionAll = {
        name : "Tất cả",
        _id : "-1"
      }

      this.selectOrderUnit = optionAll;
      this.orderUnits = [optionAll].concat(contextArr);
    },

    async getProvince() {
      this.provinces = await this.$getAllProvinces();
      this.selectProvince = this.provinces[0];
    },

    async getDistrictByProvinceID(provinceId) {
      const contextArr = await this.$getDistrictByProvince(provinceId);
      const optionAll = {
        district_name : "Tất cả",
        _id : "-1"
      }

      this.selectDistrict = optionAll;
      this.districts = [optionAll].concat(contextArr);
    }
  },
}
</script>

<style scoped>

.v-text-field .v-input__control .v-input__slot {
  min-height: 45px !important;
  /* display: flex !important; */
  align-items: center !important;
}
</style>
